import { render, staticRenderFns } from "./listinformasi.vue?vue&type=template&id=ca0b8254&"
import script from "./listinformasi.vue?vue&type=script&lang=js&"
export * from "./listinformasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports